import { I18n } from '@calendly/i18n'
import { useSelector } from 'react-redux'

import { isOnTrialStageSelector, trialEndsAtSelector, useDateFormat } from 'features/billing'
import { isAdminOrOwnerSelector } from 'selectors/current_user'

import { UpgradeBanner } from './upgrade_banner'

export const TrialBanner = () => {
  const isOnTrial = useSelector(isOnTrialStageSelector)
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const trialEndsAt = useSelector(trialEndsAtSelector)
  const i18nParams = { date: useDateFormat(trialEndsAt) }

  if (!isOnTrial) { return null }

  const bannerCopy = isOwnerOrAdmin
    ? I18n.t('publisher.workflows.trial_upgrade.message_banner_html', i18nParams)
    : I18n.t('publisher.workflows.contact_admin_to_enable_on_trial.message_banner_html', i18nParams)

  return (
    <UpgradeBanner
      containerId="workflows-trial-banner"
      bannerCopy={bannerCopy}
    />
  )
}
